import { useEffect, useRef } from 'react'
import { useAuth } from './use-auth'
import { supabase } from '@/integrations/supabase/client'

const EDGE_FUNCTION_URL = import.meta.env.VITE_EDGE_FUNCTION_URL || 
  'https://xuqkgeusasosxtcfhbwj.supabase.co/functions/v1'

/**
 * Hook that automatically syncs billing on user login
 * Fire-and-forget - doesn't block the UI
 */
export function useBillingSync() {
  const { user } = useAuth()
  const syncedRef = useRef(false)

  useEffect(() => {
    // Only sync once per session
    if (!user || syncedRef.current) {
      return
    }

    syncedRef.current = true
    syncBilling()
  }, [user])

  async function syncBilling() {
    if (!user) return

    try {
      console.log('Starting billing sync for user:', user.id)

      const { data: { session } } = await supabase.auth.getSession()
      
      if (!session?.access_token) {
        console.warn('No access token, skipping billing sync')
        return
      }

      const response = await fetch(`${EDGE_FUNCTION_URL}/sync-billing`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) {
        console.warn('Billing sync failed:', response.status)
        return
      }

      const data = await response.json()
      
      if (data.ok) {
        console.log('Billing sync successful:', {
          count: data.count,
          customerId: data.customerId,
          customerCreated: data.customerCreated
        })
      } else if (data.stale) {
        console.warn('Billing sync returned stale data, riding cache')
      }
    } catch (error) {
      // Silent failure - don't interrupt user experience
      console.warn('Billing sync error (non-fatal):', error)
    }
  }

  return { syncBilling }
}
